import React, { Component } from 'react';
import { connect } from 'react-redux';

import Accordion from '../Global/Accordion';
import Button from '../Global/Button';
import Select from 'react-select';

import { isEqual } from '../../helpers/commonHelpers';

import { getMunicipalities, setMunicipalityFilters } from '../../store/actions/municipalityActions';
import { filterSelect } from '../../helpers/selectStyles';
import { entities, cantons, initialMunicipalityFilters } from '../../helpers/informationHelpers';

import filter from '../../assets/icons/filter.svg';

class Filters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            oldFilters: {
                ...this.props.filters,
            }
        }
    }
    
    render() {
        const { totalMunicipalities, filters, fetchingMunicipalities, municipalitiesShown, region } = this.props;

        return (
            <div className={`filters ${fetchingMunicipalities ? 'unclickable' : ''}`}>
                <h1 className="filters__title">
                    Filteri
                    <img src={filter} alt="filter" className="filters__icon" />
                    {!isEqual(filters, initialMunicipalityFilters) ? 
                        <span className="filters__button-container">
                            <Button classes="filters__reset" color="black" onClick={this.handleResetFilters} text={'Reset Filters'} />
                        </span> : null}
                </h1>
                <p className="filters__results">
                    <span className="gray-text bold"> {totalMunicipalities ? totalMunicipalities : 0} </span> {region ? (region === 'FB' ? 'općina' : 'opština') : null} pronađen{totalMunicipalities !== 1 ? 'o' : 'a'}, <span className="gray-text bold"> { municipalitiesShown ? municipalitiesShown : 0} </span> prikazano
                </p>

                <Accordion isExpandable={false} title="Entitet">
                    <Select placeholder="Odaberi.." value={this.selectedEntity()} onChange={this.handleEntityChange} styles={filterSelect} isSearchable={true} options={entities} />
                </Accordion>
                
                <Accordion isExpandable={false} title="Kanton">
                    <Select placeholder="Odaberi.." value={this.selectedCanton()} onChange={this.handleCantonChange} styles={filterSelect} isSearchable={true} options={cantons} isMulti={true} />
                </Accordion>

                {this.showApplyFilters() ? <Button classes="filters__apply" color="yellow-gradient" onClick={this.applyFilters} text={`Apply Filters`} /> : null}
            </div>
        );
    }
    selectedCanton = () => {
        const { filters } = this.props;

        const selectedCantons = cantons.filter(canton => {
            return filters.cantons.includes(canton.value);
        });

        return selectedCantons;
    }
    handleCantonChange = (cantons) => {
        const { filters } = this.props;
        if (cantons) {
            const values = cantons && cantons.map(canton => {
                return canton.value;
            });
            filters.cantons = values;
        }
        else
            filters.cantons = [];

        this.modifyFilters(filters);
    }
    
    selectedEntity = () => {
        const { filters } = this.props;
        if (!filters?.entity) return null;
        return { value: filters?.entity, label: filters?.entity === 'RS' ? 'Republika Srpska' : 'Federacija' }
    }
    handleEntityChange = (entity) => {
        const { filters } = this.props;

        filters.entity = entity?.value;

        this.modifyFilters(filters);
    }
    showApplyFilters = () => {
        const { filters } = this.props;
        const { oldFilters } = this.state;
        return (
            !isEqual(oldFilters, filters) 
        );
    }

    applyFilters = () => {
        const { filters, getMunicipalities } = this.props;
        document.getElementById('municipalityHero').scrollIntoView({behavior: 'smooth'});
        
        this.setState({
            oldFilters: {...filters}
        }, () => {
            getMunicipalities(filters);
        })
    }

    handleResetFilters = () => {
        this.setState({
            oldFilters: {
                ...initialMunicipalityFilters
            }
        }, () => {
            const newFilters = {
                ...initialMunicipalityFilters
            };
            this.props.setMunicipalityFilters(newFilters);
            this.props.getMunicipalities(newFilters);
        })      
    }

    modifyFilters = (filters) => {
        const newFilters = {
            ...filters
        };
        this.props.setMunicipalityFilters(newFilters);
    }
}

const mapStateToProps = (state) => {
    return {
        totalMunicipalities: state.municipalities.totalMunicipalities,
        filters: state.municipalities.filters,
        fetchingMunicipalities: state.municipalities.fetchingMunicipalities,
        municipalitiesShown: state.municipalities.municipalitiesShown,
        region: state.common.region
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setMunicipalityFilters: (filters) => { dispatch(setMunicipalityFilters(filters)) },
        getMunicipalities: (filters) => { dispatch(getMunicipalities(filters))},
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Filters);